import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);

export function dayjsToTimeZoneUnix(date: string | number | dayjs.Dayjs | Date, timezone: string) {
    return dayjs(date).unix() + dayjs(date).tz(timezone).utcOffset() * 60;
}

// Preset offsets are applied to UTC dates by reporting and change logs.
// Keep the same UTC calendar boundaries as the legacy dashboard, regardless of browser timezone.
export function getCurrentHour() {
    return dayjs.utc().hour();
}

export function getCurrentWeek() {
    return dayjs.utc().diff(dayjs.utc().startOf('isoWeek'), 'hour');
}

export function getLastWeek() {
    return dayjs.utc().diff(dayjs.utc().subtract(1, 'week').startOf('isoWeek'), 'hour');
}

export function getCurrentMonth() {
    return dayjs.utc().diff(dayjs.utc().startOf('month'), 'hour');
}

export function getLastMonth() {
    return dayjs.utc().diff(dayjs.utc().subtract(1, 'month').startOf('month'), 'hour');
}

export function getPastDays(days) {
    return dayjs.utc().diff(dayjs.utc().subtract(days, 'day').startOf('day'), 'hour');
}
